import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {AutopayThresholdExceededPanel} from "./AutopayThresholdExceededPanel";
import {Messages} from "../../../../Messages";


export class InsufficientFundsPanel extends AutopayThresholdExceededPanel {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            text: Messages.insufficientFunds,
            linkText: "",
        }
    }
}
